import React, { FC } from "react";

import { AIAvatar, Avatar } from "~/components/atoms";

import {
  AiEmployeeConversationSender,
  AiEmployeeConversationType,
} from "~/domains";

type PropsType = {
  className?: string;
  conversation: AiEmployeeConversationType;
  currentEmployeeAvatarUrl: string;
};

export const ChatDetail: FC<PropsType> = ({
  conversation,
  currentEmployeeAvatarUrl,
  className = "",
}: PropsType) => {
  return (
    <div className={`flex ${className}`}>
      {conversation.senderType.type ===
      AiEmployeeConversationSender.assistant.type ? (
        <AIAvatar type="neutralExpression" size="sm" />
      ) : (
        <Avatar src={currentEmployeeAvatarUrl} size="sm" />
      )}
      <p className="whitespace-pre-wrap bg-secondary-200 rounded-xl ml-4 p-4">
        {conversation.message}
      </p>
    </div>
  );
};
